import { useEffect, useState, useCallback } from 'react';

import mapboxgl from 'mapbox-gl';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import { useHistory, Redirect, useParams } from 'react-router-dom';
import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import { getSurveyId } from '../../App';
import Spinner from '../../Components/Spinner/Spinner';
import useQuery from '../../hooks/useQuery';
import MTClientRequirementCircleComponent from '../../MobileTab/MTClientRequirementCircleComponent';
import MTGallaryModeComponent from '../../MobileTab/MTGallaryModeComponent';
import MTImageCarouselComponent from '../../MobileTab/MTImageCarouselComponent';
import * as constNames from '../../models/constant';
import { CUSTOM_CLIENT_NAME } from '../../models/headers';
import { Routes as AppRoutes } from '../../models/routes';
import * as actionTypes from '../../store/actions/index';
import {
  calcCapacity,
  calcMonthTerms,
  formatDate,
  getCurrentLocationCoordinates,
  getDistanceFromLatLong,
  hasValidSurveyID,
  validateImageURLString,
} from '../../utils/utils';
import ImageGallery from '../common/ImageGallery/ImageGallery';
import MaterialAlternateEmailIcon from '../Core/MaterialIcons/MaterialAlternateEmailIcon';
import MaterialEventAvailableIcon from '../Core/MaterialIcons/MaterialEventAvailableIcon';
import MaterialFmdGoodIcon from '../Core/MaterialIcons/MaterialFmdGoodIcon';
import MaterialLeftArrowIcon from '../Core/MaterialIcons/MaterialLeftArrowIcon';
import NoteAltIcon from '../Core/MaterialIcons/MaterialNoteAltIcon';
import MaterialRequestQuoteIcon from '../Core/MaterialIcons/MaterialRequestQuoteIcon';
import MaterialTranspotationIcon from '../Core/MaterialIcons/MaterialTranspotationIcon';

const PHOTOS = 'PHOTOS';
const FLOOR_PLAN = 'FLOOR_PLAN';

const BackButton = ({ onClickHandler }) => {
  return (
    <div className="back-button-container">
      <span onClick={onClickHandler} className="back-button">
        <MaterialLeftArrowIcon />
        <span>Back</span>
      </span>
    </div>
  );
};

const getFloorPlanImage = (option) => {
  if (option && option?.floorPlan) {
    return [
      option?.floorPlan.replace(
        process.env.REACT_APP_PDF_IMAGE_URL.trim(),
        process.env.REACT_APP_PDF_REPLACE_IMAGE_URL.trim(),
      ),
    ];
  }
  if (option && option?.floorPlan && option?.floorPlan.includes('us-east-1')) {
    return [
      option?.floorPlan.replace(
        process.env.REACT_APP_PDF_HERO_IMAGE_URL.trim(),
        process.env.REACT_APP_PDF_REPLACE_IMAGE_URL.trim(),
      ),
    ];
  }
};

const imgStyle = {
  maxWidth: 500,
  maxHeight: 300,
};

const initMonthTerms = {
  rateOneMonth: '',
  rateSixMonths: '',
  rateTwelveMonths: '',
  ratetwentyfourmonths: '',
  rateVariable: '',
};

function shouldDisplayDiv(contents) {
  const isContentEmpty = (htmlContent) => {
    if (!htmlContent) return true;

    const tempDiv = document.createElement('div');

    tempDiv.innerHTML = htmlContent;

    return (
      !tempDiv.textContent.trim() &&
      Array.from(tempDiv.childNodes).every(
        (child) => child.childNodes.length === 0 || isContentEmpty(child.innerHTML),
      )
    );
  };

  return contents.some((content) => !isContentEmpty(content));
}

const MobileOptionDetail = (props) => {
  const [IsSpinner, SetIsSpinner] = useState(false);
  const { surveyData, commonQuery, currentDeal, latLong, options, pdfDownload } = props;
  const [carouselState, setCarouselState] = useState(FLOOR_PLAN);
  const [currentLocationsLatLongs, setCurrentLocationsLatLongs] = useState([]);
  const [selectedPhotoIndex, setPhotoIndex] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);
  const [open, setOpen] = useState(false);
  const [galleryMode, setGalleryMode] = useState(false);
  const { id } = useParams();
  let rateVariableTerm = '';
  let monthTerms = initMonthTerms;
  const isPhotoState = carouselState === PHOTOS;
  const history = useHistory();
  const dispatch = useDispatch();
  const selectedIndex = Number.isNaN(parseInt(id, 10)) ? -1 : parseInt(id, 10);
  const pathParams = location.pathname.split('/');
  const surveyId = getSurveyId(pathParams);
  const query = useQuery();
  const isShortlisted = query.get(constNames.IS_SHORTLISTED);
  const clientCurrentLocation = useSelector((state) => state?.comRed?.displayCurrentLocation);

  mapboxgl.accessToken = `${process.env.REACT_APP_MAPBOX_KEY}`.trimEnd();

  const toggleCarouselState = (state) => {
    setPhotoIndex(0);
    setCarouselState(state);
  };

  const imageUrlProcessing = (option) => {
    const imageList = [];

    if (option && option?.images) {
      let customImages = option?.images;

      if (option?.floorPlan) {
        customImages = option?.images?.split(',')?.filter((img) => img !== option?.floorPlan);
      }

      customImages.map((image) => imageList.push(encodeURI(image)));
    }

    const imageFinalList = imageList?.filter((url, index) => {
      return validateImageURLString(url);
    });

    return imageFinalList;
  };

  const getLatLong = useCallback(async () => {
    if (clientCurrentLocation) {
      const currentLocationCoordinates = await getCurrentLocationCoordinates(clientCurrentLocation);

      if (currentLocationCoordinates.data.results.length > 0) {
        const currentCoordnates = [
          currentLocationCoordinates.data.results[0].geometry.location.lng,
          currentLocationCoordinates.data.results[0].geometry.location.lat,
        ];

        setCurrentLocationsLatLongs(currentCoordnates);
        props.setLatLong(currentCoordnates);
      }
    } else {
      props.setLatLong([]);
    }
  }, [clientCurrentLocation, props]);

  const getDistance = (option, unitVal, latLong) => {
    if (option && option?.lat && option?.lng) {
      const latLng = latLong;

      if (latLng && latLng.length > 0) {
        const lat1 = latLng[1];
        const lat2 = option?.lat;
        const lon1 = latLng[0];
        const lon2 = option?.lng;
        const distance1 = Math.round(getDistanceFromLatLong(lat1, lon1, lat2, lon2, unitVal));

        const unit = unitVal == 'miles' ? 'Miles ' : 'KM ';

        return distance1 + ' ' + unit;
      }

      return '';
    }

    return '';
  };

  useEffect(() => {
    if (currentLocationsLatLongs?.length === 0) {
      setTimeout(() => {
        getLatLong();
      }, 100);
    }
  }, [currentLocationsLatLongs?.length, getLatLong]);

  const data = useSelector((state) => state?.optRed?.data);

  useEffect(() => {
    if (!options) {
      if (
        !pdfDownload &&
        surveyId
        // hasValidSurveyID(surveyId)
      ) {
        SetIsSpinner(true);
        dispatch(actionTypes.providerAction(surveyId, isShortlisted, false, false));
      }
    }
  }, [dispatch, isShortlisted, options, pdfDownload, surveyId]);

  useEffect(() => {
    if (Object.keys(currentDeal)?.length > 0) {
      SetIsSpinner(false);
    }
  }, [currentDeal]);

  useEffect(() => {
    if (data && data?.dealId) {
      dispatch(actionTypes.flexpertEmailAction(data.dealId, 'CLIENT'));
    }
  }, [data, dispatch]);

  const option = options?.find((opt) => opt.id === id);

  const imageList = imageUrlProcessing(option);
  const floorPlanImg = getFloorPlanImage(option) || [];

  // onmount load variables
  if (option && option?.availableSpaceList) {
    monthTerms = calcMonthTerms(option);
  }

  if (option && option?.rateVariableTerm) {
    rateVariableTerm = option?.rateVariableTerm?.split(' ')[0]?.trim();
  }

  const toggleCarouselStateCB = useCallback((cb) => {
    setCarouselState(cb);
  }, []);

  const setPhotoIndexCB = useCallback((cb) => {
    setPhotoIndex(cb);
  }, []);

  const galleryModeCB = useCallback((cb) => {
    setGalleryMode(cb);
  }, []);

  useEffect(() => {
    // Check if the surveyId is not found in the data array and redirect  to options page
    if (options?.length > 0) {
      const urlOptionId = pathParams.slice(-1)[0];
      const idExists = options?.some((item) => item.id === urlOptionId);

      if (!idExists) {
        history.push(`${AppRoutes.MOBILE_BASE}/${surveyId}/totaloptions`);
      }
    }
  }, [history, options, pathParams, surveyId]);

  return (
    <>
      {IsSpinner && <Spinner />}

      <AllOptionsMainWrapper>
        <MTClientRequirementCircleComponent surveyData={surveyData} currentDeal={currentDeal} />
        {options?.length > 0 && (
          <>
            {galleryMode ? (
              <MTGallaryModeComponent
                galleryMode={galleryMode}
                isPhotoState={isPhotoState}
                imageList={imageList}
                floorPlanImg={floorPlanImg}
                galleryModeCB={galleryModeCB}
                setPhotoIndexCB={setPhotoIndexCB}
                toggleCarouselStateCB={toggleCarouselStateCB}
              />
            ) : (
              <>
                <div className="mobile-content">
                  {imageList?.length > 0 && (
                    <MTImageCarouselComponent
                      imageList={imageList}
                      galleryMode={galleryMode}
                      floorPlanImg={floorPlanImg}
                      isPhotoState={isPhotoState}
                      carouselState={carouselState}
                      setPhotoIndex={setPhotoIndex}
                      setPhotoIndexCB={setPhotoIndexCB}
                      galleryModeCB={galleryModeCB}
                      toggleCarouselStateCB={toggleCarouselStateCB}
                    />
                  )}
                  <div className="common-width-od-page">
                    <p className="mobile-title mb-2">{`${option?.optionName}`}</p>
                    <p className="mobile-small-subtitle mb-2">{option?.address?.address}</p>
                    {currentDeal &&
                      Object.keys(currentDeal)?.length > 0 &&
                      props.latLong?.length > 0 && (
                        <div className="availability-wrapper-block">
                          <p className="mobile-subtitle icon-cont-align">
                            <MaterialFmdGoodIcon className="mr-2" />
                            Distance from current location
                          </p>
                          <p className="mobile-text availability-content-block">
                            {currentDeal?.['Client Name']?.[0].toLowerCase() ===
                            CUSTOM_CLIENT_NAME.toLowerCase()
                              ? option &&
                                option?.address &&
                                getDistance(option?.address, 'km', props.latLong)
                              : option &&
                                option?.address &&
                                getDistance(option?.address, 'miles', props.latLong)}
                          </p>
                        </div>
                      )}

                    <div className="pricing-wrapper-content">
                      <div className="icon-cont-align">
                        <MaterialEventAvailableIcon className="mr-2" />
                        <span className="mobile-subtitle">Availability</span>
                      </div>
                      <div className="pricing-val-wrapper availability-val-wrapper">
                        <div className="pricing-val-cont ">
                          <p className="mobile-subtitle">Desks</p>
                          <p className="mobile-subtext">{calcCapacity(option)}</p>
                        </div>
                        <div className="pricing-val-cont ">
                          <p className="mobile-subtitle">Date</p>
                          <p className="mobile-subtext">{formatDate(option)}</p>
                        </div>
                      </div>
                    </div>
                    <div className="pricing-wrapper-content">
                      <div className="icon-cont-align">
                        <MaterialRequestQuoteIcon className="mr-2" />
                        <span className="mobile-subtitle">Pricing</span>
                      </div>
                      <div className="pricing-val-wrapper">
                        {option?.ratesToInclude && option?.ratesToInclude.includes('12') && (
                          <div className="pricing-val-cont">
                            <p className="mobile-subtitle">12 Months</p>
                            <p className="mobile-subtext">
                              {monthTerms.rateTwelveMonths !== ''
                                ? monthTerms.rateTwelveMonths
                                : null}
                            </p>
                          </div>
                        )}

                        {option?.ratesToInclude && option?.ratesToInclude.includes('1') && (
                          <div className="pricing-val-cont">
                            <p className="mobile-subtitle">1 Month</p>
                            <p className="mobile-subtext">
                              {monthTerms.rateOneMonth !== '' ? monthTerms.rateOneMonth : null}
                            </p>
                          </div>
                        )}
                        {option?.ratesToInclude && option?.ratesToInclude.includes('6') && (
                          <div className="pricing-val-cont">
                            <p className="mobile-subtitle">6 Months</p>
                            <p className="mobile-subtext">
                              {monthTerms.rateSixMonths !== '' ? monthTerms.rateSixMonths : null}
                            </p>
                          </div>
                        )}

                        {option?.ratesToInclude && option?.ratesToInclude.includes('24') && (
                          <div className="pricing-val-cont">
                            <p className="mobile-subtitle">24 Months</p>
                            <p className="mobile-subtext">
                              {monthTerms.ratetwentyfourmonths !== ''
                                ? monthTerms.ratetwentyfourmonths
                                : null}
                            </p>
                          </div>
                        )}
                        {option?.ratesToInclude &&
                          option?.ratesToInclude.includes(rateVariableTerm) &&
                          rateVariableTerm !== '' && (
                            <div className="pricing-val-cont">
                              <p className="mobile-subtitle">
                                {option?.rateVariableTerm !== ''
                                  ? `${rateVariableTerm} Months`
                                  : null}
                              </p>
                              <p className="mobile-subtext">
                                {monthTerms.rateVariable !== '' &&
                                monthTerms.rateVariable !== 'USD 0'
                                  ? monthTerms.rateVariable
                                  : null}
                              </p>
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="content-wrapper-gap address-block-wrapper">
                      <div className="icon-cont-align">
                        <MaterialAlternateEmailIcon className="mr-2" />
                        <span className="mobile-subtitle">Office</span>
                      </div>
                      <div className="address-cont-wrapper">
                        {option?.availableSpaceList?.map((avail, indexSpace) => (
                          <div
                            key={indexSpace}
                            className="space__desc mobile-subtext align-text-block"
                          >
                            Unit {avail && avail.unit} {avail && avail.officeType}, A{' '}
                            {avail && avail.productType} with {avail && avail.capacity} desks
                            {avail && avail.floor > 0 ? ', Floor #' + avail.floor : ''}
                            {avail && avail.area ? ', Area ' + avail.area + ' ' : ''}
                            {avail && avail.area && avail.areaMeasurement
                              ? avail.areaMeasurement
                              : ''}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="mb-2">
                      <div>
                        <MaterialTranspotationIcon className="mr-2" />
                        <span className="mobile-subtitle">Amenities</span>
                        <ul className="amenities-list">
                          {option?.amenities?.split(',')?.map((amenity, index) => (
                            <li key={index}>
                              <p className="mobile-subtext">{amenity}</p>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {(option?.queryData ||
                      (surveyData && surveyData.commonQuestions) ||
                      commonQuery ||
                      option?.queryResponse ||
                      option?.notes) &&
                      shouldDisplayDiv([
                        option?.queryData,
                        surveyData?.commonQuestions,
                        commonQuery,
                        option?.queryResponse,
                        option?.notes,
                      ]) && (
                        <div className="mobile-notes">
                          <div>
                            <NoteAltIcon className="mr-2" />
                            <span className="mobile-subtitle">Notes</span>
                            <div className="notes__display">
                              {(option?.queryData ||
                                (surveyData && surveyData.commonQuestions) ||
                                commonQuery) && (
                                <span>
                                  <span>Question(s):</span>
                                  <span>
                                    {option?.queryData && (
                                      <div
                                        dangerouslySetInnerHTML={{ __html: option?.queryData }}
                                      />
                                    )}
                                    {surveyData?.commonQuestions && (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: surveyData?.commonQuestions,
                                        }}
                                      />
                                    )}
                                    {commonQuery && (
                                      <div dangerouslySetInnerHTML={{ __html: commonQuery }} />
                                    )}
                                  </span>
                                </span>
                              )}

                              {option?.queryResponse && (
                                <span>
                                  <br />
                                  <span>Response(s):</span>
                                  <div
                                    dangerouslySetInnerHTML={{ __html: option?.queryResponse }}
                                  />
                                </span>
                              )}

                              {option?.notes?.split('\n').map((text, i) => {
                                if (text) {
                                  return (
                                    <span key={i}>
                                      <div dangerouslySetInnerHTML={{ __html: text }} />
                                      <br />
                                    </span>
                                  );
                                }

                                return (
                                  <span key={i}>
                                    <br />
                                  </span>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </AllOptionsMainWrapper>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    latLong: state.comRed.latLong,
    surveyData: state.optRed.data,
    commonQuery: state.comRed.displayCommonQuery,
    currentDeal: state.comRed.currentDeal,
    options: state?.optRed?.data?.optionProviderRequestList,
    pdfDownload: state?.comRed?.pdfDownload,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLatLong: (latLng) => dispatch({ type: 'SET_LAT_LONG_CURRENT_LOCATION', latLng }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileOptionDetail);

const AllOptionsMainWrapper = styled.div`
  background-color: #fff;
  padding: 15px;
  display: grid;
  position: relative;
  width: 100vw;
  margin: 0 auto;

  -webkit-overflow-scrolling: touch;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}) and ${constNames.DEVICE_MEDIA
      .MOBILE_MAX} {
    width: 100vw;
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .LANDSCAPE}) {
    width: calc(100vw - 90px);
  }
`;
